<template>
  <div>
    <template v-for="(item, index) in question.Questions">
      <component
        v-if="item.IsVisible"
        :key="index"
        :is="item.AnswerControlType"
        :question="item"
      ></component>
    </template>
  </div>
</template>

<script>
import InputBase from "@/components/Inputs/InputBase.vue";

export default {
  name: "LayoutSolicitorEmailAddress",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputBase,
  },
};
</script>
